module.exports = __webpack_public_path__ + "img/squares.db87a896.svg";